import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"end"} }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "pl-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        size: "large",
        onClick: _cache[0] || (_cache[0] = () => _ctx.isCreateDialogOpen = true),
        style: {"width":"300px","margin-top":"16px","margin-bottom":"16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.create')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_table, { class: "mb-8" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.name')), 1),
            _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.abbreviation')), 1),
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.childcareTarget')), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.color')), 1),
            _cache[15] || (_cache[15] = _createElementVNode("th", { class: "text-left" }, null, -1))
          ])
        ]),
        _createVNode(_component_draggable, {
          modelValue: _ctx.workDescriptions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workDescriptions) = $event)),
          tag: "tbody",
          "item-key": "workDescriptionId",
          handle: ".drag-handle"
        }, {
          item: _withCtx(({ element: work }) => [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_v_icon, {
                  class: "drag-handle",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" mdi-drag ", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(work.name), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(work.abbreviation), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(work.isChildcare ? _ctx.$t('common.yes') : ''), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: "color-chip",
                  style: _normalizeStyle(`background-color: ${work.color};`)
                }, null, 4)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mx-2",
                      color: "primary",
                      variant: "outlined",
                      onClick: () => _ctx.editingWork = work
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      class: "mx-2",
                      color: "red",
                      variant: "flat",
                      onClick: () => _ctx.deletingWork = work
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isCreateDialogOpen,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCreateDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.createTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  class: "mb-4",
                  "hide-details": "",
                  variant: "outlined",
                  label: _ctx.$t('workScheduling.workDescriptionSettings.form.name'),
                  modelValue: _ctx.newWorkTitle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newWorkTitle) = $event))
                }, null, 8, ["label", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  class: "mb-4",
                  "hide-details": "",
                  variant: "outlined",
                  label: _ctx.$t('workScheduling.workDescriptionSettings.form.abbreviation'),
                  modelValue: _ctx.newWorkShorten,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newWorkShorten) = $event))
                }, null, 8, ["label", "modelValue"]),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.color')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_color_picker, {
                    modelValue: _ctx.newWorkColor,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newWorkColor) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.newWorkIsChildcare,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newWorkIsChildcare) = $event)),
                    label: _ctx.$t('workScheduling.workDescriptionSettings.form.childcareTarget'),
                    "hide-details": "",
                    density: "compact"
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  disabled: !_ctx.isNewPatternValid,
                  onClick: _ctx.createWorkDescription
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }),
            (_ctx.isCreatingNewWork)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isEditDialogOpen,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isEditDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.editingWork)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.editTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: _ctx.$t('workScheduling.workDescriptionSettings.form.name'),
                      modelValue: _ctx.editingWork.name,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingWork.name) = $event))
                    }, null, 8, ["label", "modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: _ctx.$t('workScheduling.workDescriptionSettings.form.abbreviation'),
                      modelValue: _ctx.editingWork.abbreviation,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingWork.abbreviation) = $event))
                    }, null, 8, ["label", "modelValue"]),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.tableHeaders.color')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_color_picker, {
                        modelValue: _ctx.editingWork.color,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingWork.color) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.editingWork.isChildcare,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingWork.isChildcare) = $event)),
                        label: _ctx.$t('workScheduling.workDescriptionSettings.form.childcareTarget'),
                        "hide-details": "",
                        density: "compact"
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      onClick: _ctx.updateWork
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingWork)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isDeleteDialogOpen,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isDeleteDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingWork)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.workDescriptionSettings.deleteConfirm', { name: _ctx.deletingWork.name })), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "grey",
                      class: "mx-2",
                      onClick: _cache[12] || (_cache[12] = () => _ctx.deletingWork = null)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "red",
                      class: "mx-2",
                      onClick: _ctx.deleteWork
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isDeletingWork)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}